import { ContentHistory } from '@amzn/awscat-pattern-library-service-model';
import React, { useEffect, useState } from 'react';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import Publication from '../../model/Publication';
import LoadingIndicator from '../common/LoadingIndicator';
import DiffView from './DiffView';

interface Props {
  oldHistory: ContentHistory;
  newHistory: ContentHistory;
}

interface ContentHistoryState {
  oldVersion: Publication;
  newVersion: Publication;
}

const mplService = MplServiceClientFactory.create();

const ContentHistoryDiffViewer = (props: Props) => {
  const { oldHistory, newHistory } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [contentHistory, setContentHistory] = useState<ContentHistoryState>({
    // @ts-expect-error TS2322 - strict migration
    oldVersion: null,
    // @ts-expect-error TS2322 - strict migration
    newVersion: null,
  });

  useEffect(() => {
    const fetchHistoryVersions = async () => {
      setIsLoading(true);
      try {
        const [oldVersion, newVersion] = await Promise.all(
          [oldHistory, newHistory].map((h) =>
            mplService.getPublicationByWorkflow(h.contentId, h.workflowId),
          ),
        );

        setContentHistory({
          // @ts-expect-error TS2322 - strict migration
          oldVersion,
          // @ts-expect-error TS2322 - strict migration
          newVersion,
        });
      } finally {
        setIsLoading(false);
      }
    };

    fetchHistoryVersions();
  }, [oldHistory, newHistory]);

  if (isLoading) {
    return <LoadingIndicator />;
  }

  return contentHistory?.oldVersion && contentHistory?.newVersion ? (
    <div>
      <DiffView
        leftTitle={`Version ${oldHistory.workflowId}.0`}
        rightTitle={`Version ${newHistory.workflowId}.0`}
        inlineHeader={`Version ${oldHistory.workflowId}.0 vs Version ${newHistory.workflowId}.0`}
        oldValue={contentHistory.oldVersion}
        newValue={contentHistory.newVersion}
      />
    </div>
  ) : null;
};

export default ContentHistoryDiffViewer;
